import React from 'react';
import RadioButtonGroup from 'lib/components/Checkbox/RadioButtonGroup';
import { NoticeAddOnPricingConfig } from 'lib/pricing/noticeAddOns/types';
import { ADDONS_COPY } from './addOnsCopy';
import {
  formatCents,
  getShippingPriceCents,
  ShippingSpeed,
  SHIPPING_SPEED_LABELS
} from './pricingConfig';

type WetSigShippingOptionsProps = {
  speed: ShippingSpeed;
  onSpeedChange: (speed: ShippingSpeed) => void;
  config: NoticeAddOnPricingConfig;
};

/**
 * Wet-sig shipping speed (Ground/Express/Rush). One speed per order. UI-only.
 */
export function WetSigShippingOptions({
  speed,
  onSpeedChange,
  config
}: WetSigShippingOptionsProps) {
  const speedOptions = (
    Object.keys(SHIPPING_SPEED_LABELS) as ShippingSpeed[]
  ).map(s => ({
    value: s,
    labelText: `${SHIPPING_SPEED_LABELS[s]} — ${formatCents(
      getShippingPriceCents(s, config)
    )}`
  }));

  return (
    <div className="space-y-3">
      <RadioButtonGroup
        id="wet-sig-shipping-speed"
        labelText={ADDONS_COPY.shippingLegend}
        options={speedOptions}
        value={speed}
        onChange={onSpeedChange}
        stacked
      />
      <p className="text-xs text-column-gray-400">
        {ADDONS_COPY.shippingHelpText}
      </p>
    </div>
  );
}
